module.exports = __webpack_public_path__ + "img/Frente-38-01 on.6b66efef.png";